import type { IWorkerStats } from '@/entities/worker-stats.entity';
import type { StatsPeriod } from '@/entities/admin-stats.entity';
import { api } from './http';

export async function fetchMyStats(period: StatsPeriod) {
	const { data } = await api.get<IWorkerStats>('/me/stats', { params: { period } });
	return data;
}
